// Curated list of countries with their primary timezone for stream-time conversion.
// Flags are emoji (universally supported).
export const COUNTRIES = [
    // Americas
    { code: "US-East", name: "United States (East)", flag: "🇺🇸", tz: "America/New_York" },
    { code: "US-Central", name: "United States (Central)", flag: "🇺🇸", tz: "America/Chicago" },
    { code: "US-Mountain", name: "United States (Mountain)", flag: "🇺🇸", tz: "America/Denver" },
    { code: "US-Pacific", name: "United States (Pacific)", flag: "🇺🇸", tz: "America/Los_Angeles" },
    { code: "US-Alaska", name: "United States (Alaska)", flag: "🇺🇸", tz: "America/Anchorage" },
    { code: "US-Hawaii", name: "United States (Hawaii)", flag: "🇺🇸", tz: "Pacific/Honolulu" },
    { code: "CA-East", name: "Canada (Eastern)", flag: "🇨🇦", tz: "America/Toronto" },
    { code: "CA-Central", name: "Canada (Central)", flag: "🇨🇦", tz: "America/Winnipeg" },
    { code: "CA-Mountain", name: "Canada (Mountain)", flag: "🇨🇦", tz: "America/Edmonton" },
    { code: "CA-Pacific", name: "Canada (Pacific)", flag: "🇨🇦", tz: "America/Vancouver" },
    { code: "MX", name: "Mexico", flag: "🇲🇽", tz: "America/Mexico_City" },
    { code: "BR", name: "Brazil", flag: "🇧🇷", tz: "America/Sao_Paulo" },
    { code: "AR", name: "Argentina", flag: "🇦🇷", tz: "America/Argentina/Buenos_Aires" },
    { code: "CL", name: "Chile", flag: "🇨🇱", tz: "America/Santiago" },
    { code: "CO", name: "Colombia", flag: "🇨🇴", tz: "America/Bogota" },
    { code: "PE", name: "Peru", flag: "🇵🇪", tz: "America/Lima" },
    { code: "VE", name: "Venezuela", flag: "🇻🇪", tz: "America/Caracas" },

    // Europe
    { code: "GB", name: "United Kingdom", flag: "🇬🇧", tz: "Europe/London" },
    { code: "IE", name: "Ireland", flag: "🇮🇪", tz: "Europe/Dublin" },
    { code: "FR", name: "France", flag: "🇫🇷", tz: "Europe/Paris" },
    { code: "DE", name: "Germany", flag: "🇩🇪", tz: "Europe/Berlin" },
    { code: "ES", name: "Spain", flag: "🇪🇸", tz: "Europe/Madrid" },
    { code: "PT", name: "Portugal", flag: "🇵🇹", tz: "Europe/Lisbon" },
    { code: "IT", name: "Italy", flag: "🇮🇹", tz: "Europe/Rome" },
    { code: "NL", name: "Netherlands", flag: "🇳🇱", tz: "Europe/Amsterdam" },
    { code: "BE", name: "Belgium", flag: "🇧🇪", tz: "Europe/Brussels" },
    { code: "CH", name: "Switzerland", flag: "🇨🇭", tz: "Europe/Zurich" },
    { code: "AT", name: "Austria", flag: "🇦🇹", tz: "Europe/Vienna" },
    { code: "SE", name: "Sweden", flag: "🇸🇪", tz: "Europe/Stockholm" },
    { code: "NO", name: "Norway", flag: "🇳🇴", tz: "Europe/Oslo" },
    { code: "DK", name: "Denmark", flag: "🇩🇰", tz: "Europe/Copenhagen" },
    { code: "FI", name: "Finland", flag: "🇫🇮", tz: "Europe/Helsinki" },
    { code: "PL", name: "Poland", flag: "🇵🇱", tz: "Europe/Warsaw" },
    { code: "CZ", name: "Czech Republic", flag: "🇨🇿", tz: "Europe/Prague" },
    { code: "GR", name: "Greece", flag: "🇬🇷", tz: "Europe/Athens" },
    { code: "RU", name: "Russia (Moscow)", flag: "🇷🇺", tz: "Europe/Moscow" },
    { code: "UA", name: "Ukraine", flag: "🇺🇦", tz: "Europe/Kyiv" },
    { code: "TR", name: "Turkey", flag: "🇹🇷", tz: "Europe/Istanbul" },
    { code: "RO", name: "Romania", flag: "🇷🇴", tz: "Europe/Bucharest" },
    { code: "HU", name: "Hungary", flag: "🇭🇺", tz: "Europe/Budapest" },

    // Africa
    { code: "ZA", name: "South Africa", flag: "🇿🇦", tz: "Africa/Johannesburg" },
    { code: "EG", name: "Egypt", flag: "🇪🇬", tz: "Africa/Cairo" },
    { code: "NG", name: "Nigeria", flag: "🇳🇬", tz: "Africa/Lagos" },
    { code: "KE", name: "Kenya", flag: "🇰🇪", tz: "Africa/Nairobi" },
    { code: "MA", name: "Morocco", flag: "🇲🇦", tz: "Africa/Casablanca" },
    { code: "GH", name: "Ghana", flag: "🇬🇭", tz: "Africa/Accra" },

    // Middle East & South Asia
    { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", tz: "Asia/Riyadh" },
    { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", tz: "Asia/Dubai" },
    { code: "IL", name: "Israel", flag: "🇮🇱", tz: "Asia/Jerusalem" },
    { code: "IR", name: "Iran", flag: "🇮🇷", tz: "Asia/Tehran" },
    { code: "IQ", name: "Iraq", flag: "🇮🇶", tz: "Asia/Baghdad" },
    { code: "PK", name: "Pakistan", flag: "🇵🇰", tz: "Asia/Karachi" },
    { code: "IN", name: "India", flag: "🇮🇳", tz: "Asia/Kolkata" },
    { code: "BD", name: "Bangladesh", flag: "🇧🇩", tz: "Asia/Dhaka" },
    { code: "LK", name: "Sri Lanka", flag: "🇱🇰", tz: "Asia/Colombo" },
    { code: "NP", name: "Nepal", flag: "🇳🇵", tz: "Asia/Kathmandu" },

    // East & SE Asia
    { code: "CN", name: "China", flag: "🇨🇳", tz: "Asia/Shanghai" },
    { code: "HK", name: "Hong Kong", flag: "🇭🇰", tz: "Asia/Hong_Kong" },
    { code: "TW", name: "Taiwan", flag: "🇹🇼", tz: "Asia/Taipei" },
    { code: "JP", name: "Japan", flag: "🇯🇵", tz: "Asia/Tokyo" },
    { code: "KR", name: "South Korea", flag: "🇰🇷", tz: "Asia/Seoul" },
    { code: "PH", name: "Philippines", flag: "🇵🇭", tz: "Asia/Manila" },
    { code: "VN", name: "Vietnam", flag: "🇻🇳", tz: "Asia/Ho_Chi_Minh" },
    { code: "TH", name: "Thailand", flag: "🇹🇭", tz: "Asia/Bangkok" },
    { code: "MY", name: "Malaysia", flag: "🇲🇾", tz: "Asia/Kuala_Lumpur" },
    { code: "SG", name: "Singapore", flag: "🇸🇬", tz: "Asia/Singapore" },
    { code: "ID", name: "Indonesia (Jakarta)", flag: "🇮🇩", tz: "Asia/Jakarta" },

    // Oceania
    { code: "AU-East", name: "Australia (Sydney)", flag: "🇦🇺", tz: "Australia/Sydney" },
    { code: "AU-Central", name: "Australia (Adelaide)", flag: "🇦🇺", tz: "Australia/Adelaide" },
    { code: "AU-West", name: "Australia (Perth)", flag: "🇦🇺", tz: "Australia/Perth" },
    { code: "NZ", name: "New Zealand", flag: "🇳🇿", tz: "Pacific/Auckland" },
];

export const findCountryByCode = (code) => COUNTRIES.find((c) => c.code === code);

// Try to guess country from the browser's timezone
export const guessCountry = () => {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const exact = COUNTRIES.find((c) => c.tz === tz);
        if (exact) return exact;
    } catch (e) {}
    return null;
};
